const sectionHeadingCss = `
[data-type='section-heading'] [data-attribute='card-container'] {
  padding: 40px 0;
}

[data-type='section-heading'] .card-content .card-title {
  font-size: 24px;
  text-align: center;
}

[data-type='section-heading'] .card-content .card-description {
  text-align: center;
}

[data-type='section-heading'] .card-content .card-description:not(:empty) {
  margin-top: 20px !important;
}

@container (max-width: 768px) {
  [data-type='section-heading'] [data-attribute='card-container'] {
    padding: 16px 0;
  }
}
`;

export default sectionHeadingCss;
